"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME_24H_FORMAT_REGEX = exports.TIME_12H_FORMAT_REGEX = exports.READ_ONLY_QUESTIONS = exports.PLACE_HOLDER = exports.INVALID_UPLOAD_ANSWER = exports.INVALID_DATE = exports.ERRORS_FILED = exports.DATE_TYPE = exports.DATE_TIME_VIEW_MODE = exports.DATE_INVALID_FORMAT = exports.CUSTOM_READ_ONLY_QUESTION_TYPES = exports.BOOLEAN_LABEL = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../toolboxCustom/constants");
var _PLACE_HOLDER;
var INVALID_UPLOAD_ANSWER = 'Please answer the question. The uploaded answer does not exist.';
exports.INVALID_UPLOAD_ANSWER = INVALID_UPLOAD_ANSWER;
var DATE_INVALID_FORMAT = 'The {QUESTION_TITLE} is incorrect format - should be {DATE_FORMAT}.';
exports.DATE_INVALID_FORMAT = DATE_INVALID_FORMAT;
var BOOLEAN_LABEL = {
  YES: 'Yes',
  NO: 'No'
};
exports.BOOLEAN_LABEL = BOOLEAN_LABEL;
var DATE_TYPE = {
  TIME: 'timeCustom',
  DATE_TIME: 'dateTimeCustom',
  DATE: 'dateCustom'
};
exports.DATE_TYPE = DATE_TYPE;
var DATE_TIME_VIEW_MODE = {
  TIME: 'time',
  DATE_TIME: 'dateTime',
  DATE: 'days'
};
exports.DATE_TIME_VIEW_MODE = DATE_TIME_VIEW_MODE;
var TIME_12H_FORMAT_REGEX = '^(1[0-2]|0?[1-9]):[0-5][0-9] (AM|PM)$';
exports.TIME_12H_FORMAT_REGEX = TIME_12H_FORMAT_REGEX;
var TIME_24H_FORMAT_REGEX = '^([01][0-9]|2[0-3]):([0-5][0-9])$';
exports.TIME_24H_FORMAT_REGEX = TIME_24H_FORMAT_REGEX;
var CUSTOM_READ_ONLY_QUESTION_TYPES = [_constants.TOOLBOX_TYPE.MULTI_CHECKBOX, _constants.TOOLBOX_TYPE.SINGLE_RADIO, _constants.TOOLBOX_TYPE.RADIO_GROUP, _constants.TOOLBOX_TYPE.DATE, _constants.TOOLBOX_TYPE.DROPDOWN_CUSTOM, _constants.TOOLBOX_TYPE.BOOLEAN];
exports.CUSTOM_READ_ONLY_QUESTION_TYPES = CUSTOM_READ_ONLY_QUESTION_TYPES;
var READ_ONLY_QUESTIONS = ['signaturepad', 'multipletext', 'matrix', 'matrixdropdown', 'comment', 'rating', 'ranking', 'radiogroup'];
exports.READ_ONLY_QUESTIONS = READ_ONLY_QUESTIONS;
var PLACE_HOLDER = (_PLACE_HOLDER = {}, (0, _defineProperty2.default)(_PLACE_HOLDER, _constants.TOOLBOX_TYPE.TEXT_CUSTOM, 'Enter text example'), (0, _defineProperty2.default)(_PLACE_HOLDER, _constants.TOOLBOX_TYPE.EMAIL, 'Enter email'), (0, _defineProperty2.default)(_PLACE_HOLDER, _constants.TOOLBOX_TYPE.NUMBERS, 'Enter number'), (0, _defineProperty2.default)(_PLACE_HOLDER, _constants.TOOLBOX_TYPE.PHONE, 'Enter phone number'), (0, _defineProperty2.default)(_PLACE_HOLDER, _constants.TOOLBOX_TYPE.LONG_TEXT, 'Enter text example'), (0, _defineProperty2.default)(_PLACE_HOLDER, _constants.TOOLBOX_TYPE.TEXT, 'Enter text example'), (0, _defineProperty2.default)(_PLACE_HOLDER, _constants.MODEL_QUESTIONS.NUMBER, 'Enter number'), _PLACE_HOLDER);
exports.PLACE_HOLDER = PLACE_HOLDER;
var ERRORS_FILED = {
  requiredError: ''
};
exports.ERRORS_FILED = ERRORS_FILED;
var INVALID_DATE = 'Invalid date';
exports.INVALID_DATE = INVALID_DATE;